import React, { Component } from 'react';

export default class FloatingParticles extends Component {
    constructor(props) {
        super(props);
        this.canvasRef = React.createRef();
        this.particles = [];
        this.animationFrameId = null;
    }

    componentDidMount() {
        this.initCanvas();
        this.animate();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        cancelAnimationFrame(this.animationFrameId);
        window.removeEventListener('resize', this.handleResize);
    }

    initCanvas = () => {
        const canvas = this.canvasRef.current;
        if (!canvas) return;
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        this.ctx = canvas.getContext('2d');
        this.createParticles();
    };

    handleResize = () => {
        const canvas = this.canvasRef.current;
        if (canvas) {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            this.createParticles();
        }
    };

    createParticles = () => {
        const count = Math.floor((window.innerWidth * window.innerHeight) / 8000); // تعداد متناسب با صفحه
        this.particles = [];
        for (let i = 0; i < count; i++) {
            this.particles.push({
                x: Math.random() * window.innerWidth,
                y: Math.random() * window.innerHeight,
                radius: Math.random() * 3 + 1, // سایز ۱ تا ۴ پیکسل
                speedX: (Math.random() - 0.5) * 0.4, // حرکت افقی آرام
                speedY: -(Math.random() * 0.8 + 0.3), // حرکت رو به بالا
                opacity: Math.random() * 0.5 + 0.2,
                color: this.getRandomBlueColor(),
            });
        }
    };

    getRandomBlueColor = () => {
        // رنگ‌های آبی ملایم
        const blues = [
            'rgba(59, 130, 246, 0.6)',   // blue-500
            'rgba(99, 102, 241, 0.55)',  // indigo-500
            'rgba(129, 140, 248, 0.5)',  // violet-400
            'rgba(14, 165, 233, 0.5)',   // sky-500
        ];
        return blues[Math.floor(Math.random() * blues.length)];
    };

    animate = () => {
        const canvas = this.canvasRef.current;
        const ctx = this.ctx;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        this.particles.forEach(p => {
            // به‌روزرسانی موقعیت
            p.x += p.speedX;
            p.y += p.speedY;

            // بازنشانی ذره‌ای که از بالا خارج می‌شود
            if (p.y + p.radius < 0) {
                p.y = canvas.height + p.radius;
                p.x = Math.random() * canvas.width;
            }
            // اگر از چپ یا راست خارج شد، برعکس کنیم
            if (p.x < 0) p.x = canvas.width;
            if (p.x > canvas.width) p.x = 0;

            // ترسیم
            ctx.beginPath();
            ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
            ctx.fillStyle = p.color;
            ctx.fill();
        });

        this.animationFrameId = requestAnimationFrame(this.animate);
    };

    render() {
        return (
            <canvas
                ref={this.canvasRef}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 0,
                    pointerEvents: 'none', // برای اینکه روی فرم کلیک شود
                }}
            />
        );
    }
}